<style scoped>
.navbar {
  z-index: -1;
}
</style>

<template lang="pug">
  div.billboard-parallax
    slot(name='billboard' :content='billboard' slot-scope='test' :data='{shop: shop}')
    div
      .navbar(v-if='fixDeliveryBar')
      app-delivery-bar(ref='deliveryBar' :fixed='fixDeliveryBar' @openModal='openModal')
      .container
        .vspace.large.hide-on-med-and-down
        page-supplier-drinks(:shop='shop', @openModal='openModal', @closeModal='closeModal')
</template>
<script>
import AppDrinkFilter from '@/components/app-drink-filter'
import PageSupplierDrinks from '@/components/page-supplier-drinks'
import AppDeliveryBar from '@/components/app-delivery-bar'
import ScrollMonitor from 'scrollmonitor'
import SupplierDetailsBillboard from '@/components/page-supplier-details-billboard'

export default {
  props: ['supplier'],
  data () {
    return {
      billboard: SupplierDetailsBillboard,
      shop: this.supplier,
      activeCategory: null,
      searchKey: null,
      fixDeliveryBar: false
    }
  },
  computed: {
    photo () {
      return this.shop
        && this.shop.photos
        && this.shop.photos.big
        ? this.shop.photos.big
        : null
    }
  },
  created () {
    this.getShop()
  },
  mounted () {
    let scrollWatcher = ScrollMonitor.create(this.$refs.deliveryBar.$el, 64)

    if (scrollWatcher.top <= 0) {
      this.fixDeliveryBar = true
      scrollWatcher = ScrollMonitor.create(this.$refs.deliveryBar.$el, 128)
    }

    scrollWatcher.stateChange(() => {
      this.fixDeliveryBar = scrollWatcher.isAboveViewport
    })
  },
  methods: {
    openModal (params) {
      this.$emit('openModal', params)
    },
    closeModal () {
      this.$emit('closeModal')
    },
    getShop () {
      this.$http
        .get(`${this.$config.API_URL}/shops/${this.$route.params.shopCode}`)
        .then(result => {
          this.shop = result.data
          this.$store.dispatch('cart/setLocation', this.shop.location)
          return result.data
        })
    },
    onSearch (searchKey) {
      this.searchKey = searchKey
    },
    filterCategory (category) {
      this.activeCategory = category
    }
  },
  components: {
    AppDrinkFilter,
    PageSupplierDrinks,
    AppDeliveryBar
  }
}
</script>



// WEBPACK FOOTER //
// src/components/page-supplier-details.vue